import { render, staticRenderFns } from "./Listar.vue?vue&type=template&id=2bf8f4aa"
import script from "./Listar.vue?vue&type=script&lang=js"
export * from "./Listar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports